import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter([
	{
		path: '*',
		lazy: () => import('./App')
	},
	{
		path: '/:sessionKey/document-faq',
		lazy: () => import('../Faq/Faq')
	},
	{
		path: '/get-app',
		lazy: () => import('../GetApp/GetApp')
	}
]);

const AppRoutes = () => {
	return <RouterProvider router={router} />;
};

export default AppRoutes;
